/**
 * Switches Initial Response between the original tab stepper and the forms
 * view.
 *
 * Only ever reachable before escalation, since `InitialResponsePage` is the
 * only thing that renders it and that page redirects an escalated incident to
 * the Planning P dashboard.
 */

import React from 'react';

import { ToggleGroup, ToggleGroupItem } from '@/components/ui/toggle-group';
import type { InitialResponseView } from 'utils/initialResponseView';

export const InitialResponseViewToggle: React.FC<{
  view: InitialResponseView;
  onChange: (next: InitialResponseView) => void;
}> = ({ view, onChange }) => (
  // Dark mode here is class-scoped with no provider above it, so without this the group resolves its tokens against
  // light-mode values and the unselected label all but disappears on the dark page.
  <div className="dark tw:text-foreground" data-tour="ir-view-toggle">
    <ToggleGroup
      variant="outline"
      size="sm"
      spacing={0}
      multiple={false}
      value={[view]}
      onValueChange={(next) => {
        const value = Array.isArray(next) ? next[0] : next;
        if (value === 'legacy' || value === 'new') onChange(value);
      }}
      aria-label="Initial response view"
      data-testid="initial-response-view-toggle"
    >
      <ToggleGroupItem value="legacy">Legacy</ToggleGroupItem>
      <ToggleGroupItem value="new" data-tour="ir-view-toggle-new">
        New
      </ToggleGroupItem>
    </ToggleGroup>
  </div>
);

export default InitialResponseViewToggle;
